import Modal from "@modalSrc/Modal";

type ReportOption = {
  reportDefinitionId: number;
  name: string;
};

type ReportSelectModalProps = {
  isOpen: boolean;
  reports: ReportOption[];
  onClose: () => void;
  onSelect: (report: ReportOption) => void;
};

export default function ReportSelectModal({ isOpen, reports, onClose, onSelect }: ReportSelectModalProps) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Select Report"
      size="md"
      className="reportSelectModal"
      footer={(
        <div className="footerRight">
          <button type="button" className="btn btn-secondary" onClick={onClose}>Cancel</button>
        </div>
      )}
    >
      <div className="reportSelectModalBody">
        {reports.map((report) => (
          <button
            key={report.reportDefinitionId}
            type="button"
            className="btn btn-secondary reportSelectButton"
            onClick={() => onSelect(report)}
          >
            <span>{report.name}</span>
          </button>
        ))}
      </div>
    </Modal>
  );
}
